export const CopiedToClipboard = "Copied to clipboard!";
export const CopyToClipboard = "Copy to clipboard";
